import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiCheck, FiRotateCcw, FiX } from "react-icons/fi";
import "../css/delivery.scss";
import "../css/returns.scss";
import siteConfig from "../config/siteConfig";

function Returns() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="returns service-page app-page-enter">
      <header className="service-page__hero returns__hero">
        <div><p className="eyebrow">Service / Returns</p><h1>Give good trousers<br /><em>a little time.</em></h1></div>
        <div><p>De fit voel je pas wanneer je beweegt. Daarom krijg je 30 dagen om thuis rustig te passen en te beslissen.</p><a className="text-link" href="#return-steps">Zo werkt het <FiArrowRight aria-hidden="true" /></a></div>
      </header>

      <section className="service-page__facts returns__facts">
        <article><span>01</span><strong>30 dagen</strong><p>Vanaf de dag van levering</p></article>
        <article><span>02</span><strong>Ongedragen</strong><p>Met originele labels bevestigd</p></article>
        <article><span>03</span><strong>14 dagen</strong><p>Voor verwerking na ontvangst</p></article>
      </section>

      <section className="service-page__journey returns__steps" id="return-steps">
        <div><p className="eyebrow">Four easy steps</p><h2>Van passen<br />tot terugbetaling.</h2></div>
        <ol>
          <li><span>01</span><div><h3>Meld je retour</h3><p>Stuur je ordernummer en de artikelen naar {siteConfig.contact.email}.</p></div></li>
          <li><span>02</span><div><h3>Verpak zorgvuldig</h3><p>Gebruik bij voorkeur de oorspronkelijke verpakking en bescherm de labels.</p></div></li>
          <li><span>03</span><div><h3>Stuur traceerbaar</h3><p>Bewaar het verzendbewijs totdat wij de ontvangst bevestigen.</p></div></li>
          <li><span>04</span><div><h3>Refund</h3><p>Na controle bevestigen we de terugbetaling via de oorspronkelijke methode.</p></div></li>
        </ol>
      </section>

      <section className="returns__conditions">
        <header><p className="eyebrow">Return conditions</p><h2>Mooi terug,<br />zoals het aankwam.</h2></header>
        <div>
          <article className="is-positive"><FiCheck aria-hidden="true" /><h3>Wat kan terug?</h3><ul><li>Ongedragen en ongewassen artikelen</li><li>Alle labels nog bevestigd</li><li>Binnen 30 dagen aangemeld</li><li>Netjes en veilig verpakt</li></ul></article>
          <article className="is-negative"><FiX aria-hidden="true" /><h3>Wat kan niet terug?</h3><ul><li>Gedragen, gewassen of beschadigd</li><li>Op maat vermaakte artikelen</li><li>Artikelen zonder originele labels</li><li>Schade door verkeerd onderhoud</li></ul></article>
        </div>
      </section>

      <section className="returns__refund">
        <FiRotateCcw aria-hidden="true" />
        <div><p className="eyebrow">Refund</p><h2>Terug naar waar het begon.</h2><p>Na ontvangst controleren we de broek. Een goedgekeurde terugbetaling wordt binnen 14 dagen gestart. De verwerking door je bank kan daarna nog enkele werkdagen duren. Oorspronkelijke expresskosten worden niet terugbetaald.</p></div>
      </section>

      <section className="service-page__faq">
        <header><p className="eyebrow">Questions / Answers</p><h2>Over ruilen en herstellen.</h2></header>
        <div>
          <details><summary>Kan ik direct voor een andere maat ruilen?</summary><p>In deze demo is geen directe omruiling gekoppeld. Bij een echte order bestel je de juiste maat opnieuw en retourneer je het eerste paar.</p></details>
          <details><summary>Wie betaalt de retourzending?</summary><p>Tenzij een artikel fout of beschadigd aankomt, zijn de retourkosten voor de klant.</p></details>
          <details><summary>Wat als mijn artikel beschadigd aankomt?</summary><p>Mail binnen 48 uur foto&apos;s en je ordernummer; we zoeken samen een passende oplossing.</p></details>
          <details><summary>Is dit een echte retourprocedure?</summary><p>Nee. Deze front-end verwerkt geen echte bestelling, betaling of retourzending.</p></details>
        </div>
      </section>

      <section className="service-page__cta returns__cta">
        <p className="eyebrow">Not sure about your fit?</p><h2>We meten graag met je mee.</h2>
        <div><Link className="solid-button" to="/contact" onClick={scrollTop}>Vraag fitadvies <FiArrowRight aria-hidden="true" /></Link><Link className="text-link" to="/shop" onClick={scrollTop}>Terug naar collectie</Link></div>
      </section>
    </main>
  );
}

export default Returns;
